module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "menu_index"
    }
  }, [_c('ul', {
    staticClass: "articles"
  }, [(_vm.user && _vm.user.admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite process"
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user || !_vm.user.admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite dollar_currency_sign",
    attrs: {
      "title": "Buy Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite user"
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite lock",
    attrs: {
      "title": "View Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite chart_up",
    attrs: {
      "title": "tools"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("Bet Calculator")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite process",
    attrs: {
      "title": "My Account"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite email",
    attrs: {
      "title": "Blog"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite mail",
    attrs: {
      "title": "Contact Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/help'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite comment",
    attrs: {
      "title": "Need Help?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/help'
      }
    }
  }, [_vm._v("Help?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop'
      }
    }
  }, [_c('div', {
    staticClass: "img_left shop-icon",
    attrs: {
      "title": "Shop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/shop'
      }
    }
  }, [_vm._v("Shop")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-603bd817"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 295
// module chunks = 1